import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import SaveIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class FormDegreeLevel extends Component {
  static propTypes = {
    classes: PropTypes.object,
    fullScreen: PropTypes.bool,

    close: PropTypes.func,
    open: PropTypes.bool,

    degreeLevel: PropTypes.object,

    createDegreeLevel: PropTypes.func,
    updateDegreeLevel: PropTypes.func,
    deleteDegreeLevel: PropTypes.func,
    refresh: PropTypes.func,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      loading: false,
      value: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.props.open) {
      this.init(nextProps.degreeLevel);
    }
  }

  init(degreeLevel) {
    this.setState({
      loading: false,
      value: degreeLevel ? degreeLevel.value : "",
      pos: degreeLevel ? degreeLevel.pos : "",
    });
  }

  handleChange = (name) => (event) => {
    const value = event.target.value;

    this.setState({
      [name]: value,
    });
  };

  delete() {
    const { NotificationCenter } = this.context;
    NotificationCenter.sweetAlert(
      {
        title: `Are you sure ?`,
        subtitle:
          "If you delete this degree Level, you won't be able to recover it.",
        timestamp: new Date().getTime(),
        error: true,
      },
      {
        cancel: {
          label: "Cancel",
          level: "default",
          callback: () => console.log("Callback"),
        },
        confirm: {
          label: "I am sure",
          level: "error",
          callback: this.confirmDelete.bind(this),
        },
      }
    );
  }

  async confirmDelete() {
    const { deleteDegreeLevel, close, refresh, degreeLevel } = this.props;

    const { NotificationCenter } = this.context;
    close();
    const resp = await deleteDegreeLevel(degreeLevel.id);
    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: "Degree Level has been deleted.",
        success: true,
        timestamp: new Date().getTime(),
      });
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  async save() {
    const {
      updateDegreeLevel,
      createDegreeLevel,
      degreeLevel,
      refresh,
      close,
    } = this.props;

    const { value, pos } = this.state;

    const { NotificationCenter } = this.context;

    let resp = undefined;
    this.setState({ loading: true });
    if (degreeLevel) {
      resp = await updateDegreeLevel(degreeLevel.id, {
        value,
        pos: Number(pos),
      });
    } else {
      resp = await createDegreeLevel({
        value,
        pos: Number(pos),
      });
    }

    this.setState({ loading: false });

    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: degreeLevel
          ? "Degree Level has been updated."
          : "Degree Level has been created.",
        success: true,
        timestamp: new Date().getTime(),
      });

      close();
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  render() {
    const { classes, fullScreen, open, degreeLevel, close } = this.props;

    const { value, loading, pos } = this.state;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        scroll="paper"
        onClose={close}
        aria-labelledby="responsive-dialog-title"
      >
        {loading ? (
          <div className={classes.progressContainer}>
            <DialogTitle id="alert-dialog-title">Loading</DialogTitle>
            <CircularProgress />
          </div>
        ) : (
          <div>
            <DialogTitle id="responsive-dialog-title">
              {degreeLevel
                ? `${degreeLevel.value}`
                : "Let's Create a New Degree Level"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {degreeLevel
                  ? "To update the degree Level, fill the form below :"
                  : "To create a new degree Level, fill the form below :"}
              </DialogContentText>
              <Grid container spacing={24}>
                <Grid item xs={12}>
                  <TextField
                    id="value"
                    label="Value"
                    className={classes.textField}
                    value={value}
                    onChange={this.handleChange("value")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="pos"
                    label="Pos"
                    className={classes.textField}
                    value={pos}
                    onChange={this.handleChange("pos")}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              {degreeLevel ? (
                <Button
                  className={classes.delete}
                  onClick={this.delete.bind(this)}
                >
                  <DeleteIcon className={classes.leftIcon} /> Delete
                </Button>
              ) : (
                []
              )}
              <Button onClick={close}>
                <CloseIcon className={classes.leftIcon} /> Close
              </Button>
              <Button color="primary" autoFocus onClick={this.save.bind(this)}>
                <SaveIcon className={classes.leftIcon} />{" "}
                {degreeLevel ? "Save" : "Create"}
              </Button>
            </DialogActions>
          </div>
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(withMobileDialog()(FormDegreeLevel));
